/* ============================================================
   BEBEFIX THEME — Core JavaScript (v4, Turkish)
   ============================================================ */
'use strict';

/* ── Yardımcı Fonksiyonlar ────────────────────────────────── */
function formatMoney(cents) {
  if (typeof cents !== 'number' || isNaN(cents)) cents = 0;
  return '₺' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, '.').replace(/\.(\d{2})$/, ',$1');
}
/** suggest.json ürününde price / price_min / price_max = ana birim ondalık (örn. 149), kuruş değil */
function formatMoneyFromSuggestDecimal(decimal) {
  if (decimal == null || decimal === '') return formatMoney(0);
  var s = String(decimal).replace(/\s/g, '').replace(',', '.');
  var n = parseFloat(s);
  if (isNaN(n) || n < 0) return formatMoney(0);
  return formatMoney(Math.round(n * 100));
}
function suggestProductPriceLabel(p) {
  var min = p.price_min;
  var max = p.price_max;
  if (min != null && max != null && Number(min) !== Number(max)) {
    return formatMoneyFromSuggestDecimal(min) + ' – ' + formatMoneyFromSuggestDecimal(max);
  }
  if (min != null) return formatMoneyFromSuggestDecimal(min);
  if (p.price != null) return formatMoneyFromSuggestDecimal(p.price);
  return formatMoney(0);
}
function escHtml(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
function escAttr(s) {
  return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
}
/** Ürün kartı görselleri 1200×1800 (2:3) — kare CDN kırpımını dikey orana çevir */
function portraitProductImg(url) {
  if (!url) return '';
  return String(url).replace(/_(\d+)x\1\b/g, function(match, size) {
    var w = parseInt(size, 10);
    if (!w || isNaN(w)) return match;
    return '_' + w + 'x' + Math.round(w * 1.5);
  });
}
function bebefixRoutesRoot() {
  var r = window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string'
    ? window.Shopify.routes.root
    : '/';
  return r.slice(-1) === '/' ? r : r + '/';
}
function foldTr(value) {
  return String(value || '')
    .toLocaleLowerCase('tr-TR')
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ş/g, 's')
    .replace(/ı/g, 'i')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c')
    .replace(/â/g, 'a')
    .replace(/î/g, 'i')
    .replace(/û/g, 'u');
}
var storkCatalogPromise;
function loadStorkCatalog() {
  if (!storkCatalogPromise) {
    storkCatalogPromise = fetchJSON(bebefixRoutesRoot() + 'collections/all/products.json?limit=250')
      .then(function(data) { return (data && data.products) || []; })
      .catch(function() {
        storkCatalogPromise = null;
        return [];
      });
  }
  return storkCatalogPromise;
}
function storkCatalogMatches(products, query) {
  var tokens = foldTr(query).split(/\s+/).filter(Boolean);
  if (!tokens.length) return [];
  return products.filter(function(product) {
    var hay = foldTr([
      product.title,
      product.product_type,
      product.vendor,
      Array.isArray(product.tags) ? product.tags.join(' ') : ''
    ].join(' '));
    return tokens.every(function(token) {
      if (hay.indexOf(token) !== -1) return true;
      return token.length >= 4 && hay.indexOf(token.slice(0, 4)) !== -1;
    });
  });
}
function storkProductHref(product) {
  return bebefixRoutesRoot() + 'products/' + encodeURIComponent(product.handle || '');
}
function storkSuggestionHtml(product) {
  var variant = (product.variants && product.variants[0]) || {};
  var image = (product.images && product.images[0] && product.images[0].src) || '';
  var href = storkProductHref(product);
  var title = product.title || '';
  return '<a href="' + escAttr(href) + '" class="search-suggestion-item">' +
    '<img src="' + escAttr(image) + '" alt="' + escAttr(title) + '" loading="lazy" onerror="this.style.display=\'none\'">' +
    '<div class="search-suggestion-item__info">' +
      '<div class="search-suggestion-item__title">' + escHtml(title) + '</div>' +
      '<div class="search-suggestion-item__price">' + formatMoneyFromSuggestDecimal(variant.price) + '</div>' +
    '</div></a>';
}
function storkCatalogCardHtml(product) {
  var variant = (product.variants && product.variants[0]) || {};
  var image = (product.images && product.images[0] && product.images[0].src) || '';
  var href = storkProductHref(product);
  var title = product.title || '';
  var compare = variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)
    ? '<span class="price--compare">' + formatMoneyFromSuggestDecimal(variant.compare_at_price) + '</span>'
    : '';
  var atc = variant.available
    ? '<button type="button" class="product-card__mobile-atc btn btn-primary btn-sm btn-full" data-pc-atc="' + escAttr(String(variant.id || '')) + '" data-product-title="' + escAttr(title) + '">Sepete Ekle</button>'
    : '<button type="button" class="product-card__mobile-atc btn btn-secondary btn-sm btn-full" disabled style="opacity:.6;cursor:not-allowed;">Tükendi</button>';
  return '<div class="product-card" data-product-id="' + escAttr(String(product.id || '')) + '" data-product-url="' + escAttr(href) + '">' +
    '<a href="' + escAttr(href) + '" class="product-card__link-overlay" tabindex="-1" aria-hidden="true"></a>' +
    '<div class="product-card__media">' +
      (image
        ? '<img class="product-card__img product-card__img--main" src="' + escAttr(image) + '" alt="' + escAttr(title) + '" loading="lazy">'
        : '') +
    '</div>' +
    '<div class="product-card__info">' +
      '<div class="product-card__title"><a href="' + escAttr(href) + '" class="product-card__title-link">' + escHtml(title) + '</a></div>' +
      '<div class="product-card__price"><span class="price">' + formatMoneyFromSuggestDecimal(variant.price) + '</span>' + compare + '</div>' +
      atc +
    '</div></div>';
}
function debounce(fn, delay) {
  var t; return function() { var a=arguments,c=this; clearTimeout(t); t=setTimeout(function(){ fn.apply(c,a); }, delay); };
}
async function fetchJSON(url, opts) {
  var res = await fetch(url, Object.assign({ headers: {'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'} }, opts));
  if (!res.ok) throw new Error(res.statusText);
  return res.json();
}
function emit(name, detail) { document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} })); }
function isMobile() { return window.innerWidth <= 768 || 'ontouchstart' in window; }
function designGermanyBadgeHtml() {
  return '<span class="product-card__design-germany" aria-hidden="true">' +
    '<svg class="product-card__germany-flag" width="15" height="10" viewBox="0 0 1200 800" aria-hidden="true" focusable="false">' +
    '<rect width="1200" height="800" fill="#E30A17"/>' +
    '<circle cx="425" cy="400" r="200" fill="#fff"/>' +
    '<circle cx="475" cy="400" r="160" fill="#E30A17"/>' +
    '<polygon fill="#fff" points="583.334,400 764.235,458.779 652.431,304.894 652.431,495.106 764.235,341.221"/>' +
    '</svg>Made in Türkiye</span>';
}

/** ai-features.js ve diğer modüller için ortak API */
window.Stork = {
  formatMoney: formatMoney,
  formatMoneyFromSuggestDecimal: formatMoneyFromSuggestDecimal,
  suggestProductPriceLabel: suggestProductPriceLabel,
  fetchJSON: fetchJSON,
  emit: emit,
  designGermanyBadgeHtml: designGermanyBadgeHtml
};

/* ── Sticky Header ────────────────────────────────────────── */
(function() {
  var h = document.getElementById('StorkHeader');
  if (!h) return;
  var s = window.scrollY > 10;
  h.classList.toggle('scrolled', s);
  document.addEventListener('scroll', function() {
    var now = window.scrollY > 10;
    if (now !== s) { s = now; h.classList.toggle('scrolled', s); }
  }, { passive: true });
})();

/* ── Mobil Navigasyon ─────────────────────────────────────── */
(function() {
  var drawer  = document.getElementById('MobileNavDrawer');
  var overlay = document.getElementById('PageOverlay');
  var openBtns = document.querySelectorAll('[data-mobile-nav-open]');
  var closeBtn = document.getElementById('MobileNavClose');
  if (!drawer) return;
  function open() {
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false');
    overlay?.classList.add('is-visible'); document.body.style.overflow = 'hidden';
    if (openBtns[0]) openBtns[0].setAttribute('aria-expanded','true');
  }
  function close() {
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true');
    overlay?.classList.remove('is-visible'); document.body.style.overflow = '';
    if (openBtns[0]) openBtns[0].setAttribute('aria-expanded','false');
  }
  openBtns.forEach(function(b){ b.addEventListener('click', open); });
  closeBtn?.addEventListener('click', close);
  overlay?.addEventListener('click', function() {
    close();
    closeSearch();
    closeCart();
  });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') { close(); closeSearch(); closeCart(); } });
})();

/* ── Arama Çekmecesi ──────────────────────────────────────── */
var closeSearch;
(function() {
  var drawer = document.getElementById('SearchDrawer');
  var overlay = document.getElementById('PageOverlay');
  var openBtns = document.querySelectorAll('[data-search-open]');
  var closeBtn = document.getElementById('SearchClose');
  var input = document.getElementById('SearchInput');
  var clearBtn = document.getElementById('SearchClear');
  var suggestionsEl = document.getElementById('SearchSuggestions');
  var viewAllBtn = document.getElementById('SearchViewAll');
  if (!drawer) { closeSearch = function(){}; return; }

  function setSearchExpanded(openState) {
    openBtns.forEach(function(btn) { btn.setAttribute('aria-expanded', openState ? 'true' : 'false'); });
  }
  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay?.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    setSearchExpanded(true);
    setTimeout(function() {
      if (input && !input.value.trim() && window.StorkSearch) {
        window.StorkSearch.showTrending();
      }
      input?.focus();
    }, 80);
  }
  closeSearch = function() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay?.classList.remove('is-visible');
    document.body.style.overflow = '';
    setSearchExpanded(false);
  };
  openBtns.forEach(function(b){ b.addEventListener('click', open); });
  closeBtn?.addEventListener('click', closeSearch);
  clearBtn?.addEventListener('click', function() {
    if (input) { input.value = ''; input.focus(); }
    if (viewAllBtn) viewAllBtn.style.display = 'none';
    if (window.StorkSearch) window.StorkSearch.showTrending();
    else if (suggestionsEl) suggestionsEl.innerHTML = '';
  });

  var dSearch = debounce(async function(q) {
    if (!suggestionsEl) return;
    if (q.length < 2) {
      if (viewAllBtn) viewAllBtn.style.display = 'none';
      if (!q.length && window.StorkSearch) window.StorkSearch.showTrending();
      else suggestionsEl.innerHTML = '';
      return;
    }
    try {
      var root = bebefixRoutesRoot();
      var products = storkCatalogMatches(await loadStorkCatalog(), q);
      var shown = products.slice(0, 8);
      suggestionsEl.innerHTML = shown.length
        ? shown.map(storkSuggestionHtml).join('')
        : '<div style="padding:10px;font-size:13px;color:var(--color-text-muted);">Sonuç bulunamadı.</div>';
      if (viewAllBtn) {
        viewAllBtn.style.display = products.length ? 'inline-flex' : 'none';
        viewAllBtn.href = root + 'search?q=' + encodeURIComponent(q) + '&type=product';
        var viewAllLabel = document.getElementById('SearchViewAllLabel');
        if (viewAllLabel) {
          viewAllLabel.textContent = products.length > shown.length
            ? 'Tüm sonuçları gör (' + products.length + ')'
            : 'Tüm sonuçları gör';
        }
      }
    } catch (e) {
      if (suggestionsEl) {
        suggestionsEl.innerHTML = '<div style="padding:10px;font-size:13px;color:var(--color-text-muted);">Arama yüklenemedi. Tam arama sayfasını deneyin.</div>';
      }
    }
  }, 300);

  input?.addEventListener('input', function() { dSearch(this.value.trim()); });
  input?.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') {
      var term = this.value.trim();
      if (term.length < 2) {
        e.preventDefault();
        return;
      }
    }
  });
})();

/* ── Arama sayfası: mağaza araması ürün döndürmezse katalogdan doldur ── */
(function() {
  var mount = document.getElementById('CatalogSearchMount');
  if (!mount) return;
  var query = (mount.getAttribute('data-query') || '').trim();
  var status = document.getElementById('CatalogSearchStatus');
  var empty = document.getElementById('CatalogSearchEmpty');
  if (query.length < 2) {
    if (status) status.textContent = 'En az 2 karakter yazın.';
    return;
  }
  loadStorkCatalog().then(function(products) {
    var matches = storkCatalogMatches(products, query);
    if (status) {
      status.innerHTML = matches.length
        ? '"<strong>' + escHtml(query) + '</strong>" için <strong>' + matches.length + '</strong> sonuç'
        : '"<strong>' + escHtml(query) + '</strong>" için sonuç bulunamadı';
    }
    if (!matches.length) {
      if (empty) empty.style.display = 'block';
      return;
    }
    mount.innerHTML = matches.map(storkCatalogCardHtml).join('');
  }).catch(function() {
    if (status) status.textContent = 'Arama yüklenemedi. Lütfen tekrar deneyin.';
  });
})();

/* ── Sepet Yöneticisi ─────────────────────────────────────── */
var closeCart;
(function() {
  var drawer  = document.getElementById('CartDrawer');
  var overlay = document.getElementById('PageOverlay');
  var body    = document.getElementById('CartDrawerBody');
  var closeBtn = document.getElementById('CartClose');
  var openBtns = document.querySelectorAll('[data-cart-open]');
  var cfgShip = window.StorkConfig || {};
  var FREE_SHIP_THRESHOLD = Number(cfgShip.freeShippingThreshold);
  if (!FREE_SHIP_THRESHOLD || FREE_SHIP_THRESHOLD <= 0) FREE_SHIP_THRESHOLD = 100000;
  var STANDARD_SHIPPING_FEE = Number(cfgShip.standardShippingFee);
  if (!STANDARD_SHIPPING_FEE || STANDARD_SHIPPING_FEE <= 0) STANDARD_SHIPPING_FEE = 11600;
  var checkoutUrl = (drawer && drawer.getAttribute('data-checkout-url')) ? drawer.getAttribute('data-checkout-url') : '/checkout';

  if (!drawer) { closeCart = function(){}; return; }

  function setCheckoutEnabled(enabled) {
    var btn = document.getElementById('CartCheckoutBtn');
    if (!btn) return;
    if (enabled) {
      btn.setAttribute('href', checkoutUrl);
      btn.classList.remove('is-disabled');
      btn.removeAttribute('aria-disabled');
      btn.removeAttribute('tabindex');
    } else {
      btn.setAttribute('href', '#');
      btn.classList.add('is-disabled');
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('tabindex', '-1');
    }
  }

  function open() {
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false');
    overlay?.classList.add('is-visible'); document.body.style.overflow = 'hidden';
    refreshCart();
  }
  closeCart = function() {
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true');
    overlay?.classList.remove('is-visible'); document.body.style.overflow = '';
  };
  openBtns.forEach(function(b){ b.addEventListener('click', open); });
  closeBtn?.addEventListener('click', closeCart);

  async function refreshCart() {
    try {
      var cart = await fetchJSON('/cart.js');
      renderCart(cart);
      updateCartBadge(cart.item_count);
      updateShippingProgress(cart.total_price);
    } catch(e) {}
  }

  function renderCart(cart) {
    if (!body) return;
    var total = document.querySelector('[data-cart-total]');
    var count = document.querySelector('.cart-drawer__count');
    if (total) total.textContent = formatMoney(cart.total_price);
    if (count) count.textContent = cart.item_count;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><div class="cart-empty__icon"><svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg></div><p class="cart-empty__title">Sepetiniz boş</p><p class="cart-empty__sub">Harika ürünlerimizi keşfedin</p><a href="/collections/all" class="btn btn-primary btn-sm">Alışverişe Başla</a></div>';
      setCheckoutEnabled(false);
      return;
    }
    body.innerHTML = cart.items.map(function(item) {
      return '<div class="cart-item" data-key="' + item.key + '">' +
        '<a href="' + item.url + '"><img class="cart-item__img" src="' + (item.image || '') + '" alt="' + (item.title||'').replace(/"/g,'&quot;') + '" loading="lazy" onerror="this.style.display=\'none\'"></a>' +
        '<div>' +
          '<div class="cart-item__title"><a href="' + item.url + '">' + (item.product_title||item.title) + '</a></div>' +
          (item.variant_title && item.variant_title !== 'Default Title' && item.variant_title !== 'Varsayılan Başlık' ? '<div class="cart-item__variant">' + item.variant_title + '</div>' : '') +
          '<div class="cart-item__bottom">' +
            '<div class="quantity-control" style="height:34px;">' +
              '<button class="quantity-btn" type="button" data-cart-qty data-key="' + item.key + '" data-delta="-1" style="height:34px;width:32px;">−</button>' +
              '<input class="quantity-input" value="' + item.quantity + '" readonly style="height:34px;width:38px;font-size:13px;">' +
              '<button class="quantity-btn" type="button" data-cart-qty data-key="' + item.key + '" data-delta="1" style="height:34px;width:32px;">+</button>' +
            '</div>' +
            '<span class="cart-item__price">' + formatMoney(item.final_line_price) + '</span>' +
            '<button class="cart-item__remove" type="button" data-cart-remove="' + item.key + '" aria-label="Kaldır">✕</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');

    body.querySelectorAll('[data-cart-qty]').forEach(function(btn) {
      btn.addEventListener('click', async function() {
        var key = this.dataset.key, delta = parseInt(this.dataset.delta);
        var inp = this.closest('.quantity-control')?.querySelector('.quantity-input');
        var current = parseInt(inp?.value || 1);
        await updateCartItem(key, Math.max(0, current + delta));
      });
    });
    body.querySelectorAll('[data-cart-remove]').forEach(function(btn) {
      btn.addEventListener('click', async function() { await updateCartItem(this.dataset.cartRemove, 0); });
    });
    setCheckoutEnabled(true);
  }

  async function updateCartItem(key, qty) {
    try {
      var cart = await fetchJSON('/cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: qty }) });
      renderCart(cart);
      updateCartBadge(cart.item_count);
      updateShippingProgress(cart.total_price);
      emit('cart:updated', { cart: cart });
    } catch(e) {}
  }

  function updateShippingProgress(price) {
    var fill = document.getElementById('ShippingProgressFill');
    var msg  = document.getElementById('ShippingProgressMsg');
    if (!fill || !msg) return;
    var pct = Math.min(100, price / FREE_SHIP_THRESHOLD * 100);
    fill.style.width = pct + '%';
    if (price >= FREE_SHIP_THRESHOLD) {
      msg.textContent = '🎉 Ücretsiz kargo kazandınız!';
      msg.style.color = 'var(--color-accent)';
    } else {
      var left = formatMoney(FREE_SHIP_THRESHOLD - price);
      var freeTl = Math.round(FREE_SHIP_THRESHOLD / 100);
      msg.textContent =
        'Ücretsiz kargo için ' +
        left +
        ' daha. ' +
        freeTl +
        ' TL altı standart ' +
        formatMoney(STANDARD_SHIPPING_FEE) +
        '.';
      msg.style.color = '';
    }
  }

  /* Sepete Ekle — global dinleyici */
  document.addEventListener('click', async function(e) {
    var btn = e.target.closest('[data-pc-atc]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var variantId = btn.dataset.pcAtc;
    if (!variantId) return;
    var orig = btn.innerHTML;
    btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="loading-spinner"><path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" opacity=".2"/><path d="M21 12a9 9 0 0 1-9 9"/></svg>';
    btn.disabled = true;
    try {
      var cart = await fetchJSON('/cart/add.js', { method: 'POST', body: JSON.stringify({ id: variantId, quantity: 1 }) });
      await fetchJSON('/cart.js').then(function(c) {
        renderCart(c); updateCartBadge(c.item_count); updateShippingProgress(c.total_price);
        emit('cart:updated', { cart: c });
      });
      var badge = document.querySelector('[data-cart-count]');
      badge?.classList.add('bump'); setTimeout(function(){ badge?.classList.remove('bump'); }, 400);
      open();
    } catch(err) {
      showToast('Ürün sepete eklenemedi. Lütfen tekrar deneyin.', 'error');
    } finally {
      btn.innerHTML = orig; btn.disabled = false;
    }
  });

  /* Ürün sayfası / Quick View ATC formu */
  document.addEventListener('submit', async function(e) {
    var form = e.target.closest('#ProductForm');
    if (!form) return;
    e.preventDefault();
    var inQuickView = !!form.closest('#QuickViewContent');
    var atcBtn = form.querySelector('#AddToCartBtn');
    var variantId = form.querySelector('#VariantId')?.value;
    var qty = parseInt(form.querySelector('#Quantity')?.value || 1, 10);
    if (!variantId) return;
    var orig = atcBtn?.innerHTML;
    if (atcBtn) { atcBtn.disabled = true; atcBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="loading-spinner"><path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" opacity=".2"/><path d="M21 12a9 9 0 0 1-9 9"/></svg> Ekleniyor...'; }
    try {
      await fetchJSON('/cart/add.js', { method: 'POST', body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty }) });
      var cart = await fetchJSON('/cart.js');
      renderCart(cart); updateCartBadge(cart.item_count); updateShippingProgress(cart.total_price);
      emit('cart:updated', { cart: cart });
      open();
      if (inQuickView) {
        showToast('Ürün sepete eklendi.');
        window.bebefixCloseQuickView?.();
      }
    } catch(err) {
      showToast('Ürün sepete eklenemedi. Stok kontrolü yapın.', 'error');
    } finally {
      if (atcBtn) { atcBtn.disabled = false; atcBtn.innerHTML = orig || 'Sepete Ekle'; }
    }
  });

  refreshCart();
})();

/* ── Ürün kartı — tıklanınca ürüne git (ATC / hızlı işlem hariç) ── */
(function() {
  document.addEventListener('click', function(e) {
    if (e.defaultPrevented) return;
    if (e.target.closest('[data-pc-atc], [data-quick-view], [data-wishlist-toggle], .product-card__action-btn')) return;
    if (e.target.closest('a.product-card__link-overlay')) return;
    var card = e.target.closest('.product-card');
    if (!card) return;
    var url = card.dataset.productUrl
      || (card.querySelector('.product-card__title-link') && card.querySelector('.product-card__title-link').href)
      || (card.querySelector('.product-card__link-overlay') && card.querySelector('.product-card__link-overlay').href);
    if (!url || url === '#') return;
    e.preventDefault();
    window.location.assign(url);
  });
})();

/* ── Sepet Badge Güncelle ─────────────────────────────────── */
function updateCartBadge(count) {
  document.querySelectorAll('[data-cart-count]').forEach(function(el) {
    el.textContent = count;
    el.style.display = count > 0 ? '' : 'none';
  });
}

/* ── Toast Bildirimi ──────────────────────────────────────── */
function showToast(msg, type, link) {
  var t = document.getElementById('WishlistToast');
  var msgEl = document.getElementById('WishlistToastMsg');
  if (!t) {
    t = document.createElement('div');
    t.id = 'WishlistToast'; t.className = 'wishlist-toast';
    t.innerHTML = '<span id="WishlistToastMsg"></span>';
    document.body.appendChild(t);
  }
  var m = t.querySelector('#WishlistToastMsg') || t;
  m.textContent = msg;
  if (link && link.href) {
    m.appendChild(document.createTextNode(' '));
    var toastLink = document.createElement('a');
    toastLink.href = link.href;
    toastLink.textContent = link.label || 'Görüntüle';
    m.appendChild(toastLink);
  }
  t.style.background = type === 'error' ? 'var(--color-danger)' : 'var(--color-text)';
  t.style.display = 'flex';
  t.setAttribute('aria-hidden', 'false');
  /* Kısa gecikme sonra animate et */
  requestAnimationFrame(function() { t.classList.add('is-visible'); });
  clearTimeout(t._timer);
  t._timer = setTimeout(function(){
    t.classList.remove('is-visible');
    setTimeout(function(){ t.style.display = 'none'; t.setAttribute('aria-hidden','true'); }, 300);
  }, 3200);
}

/* ── Favori (Wishlist) ────────────────────────────────────── */
(function() {
  var WL_KEY = 'bebefix_wishlist';
  var WISH_URL = '/pages/favorilerim';

  function normalize(raw) {
    if (!Array.isArray(raw)) return [];
    var items = [];
    raw.forEach(function(item) {
      if (!item || typeof item !== 'object' || !item.id || !item.url) return;
      items.push({
        id: String(item.id),
        title: item.title || 'Ürün',
        handle: item.handle || '',
        url: item.url,
        image: item.image || '',
        price: item.price || '',
        variantId: item.variantId ? String(item.variantId) : ''
      });
    });
    return items;
  }
  function get() {
    try { return normalize(JSON.parse(localStorage.getItem(WL_KEY) || '[]')); }
    catch (e) { return []; }
  }
  function save(items) {
    try { localStorage.setItem(WL_KEY, JSON.stringify(items)); } catch (e) {}
    syncButtons();
    updateCount(items.length);
    renderPage(items);
  }
  function updateCount(count) {
    if (typeof count !== 'number') count = get().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el) {
      el.textContent = String(count);
      el.style.display = count > 0 ? '' : 'none';
    });
  }
  function paintButton(btn, on) {
    btn.classList.toggle('is-wishlisted', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = btn.querySelector('[data-wishlist-label]');
    if (label) label.textContent = on ? 'Favorilerde' : 'Favorilere Ekle';
    if (btn.classList.contains('product-card__action-btn')) {
      btn.title = on ? 'Favorilerden kaldır' : 'Favorilere Ekle';
      var title = btn.dataset.productTitle || '';
      btn.setAttribute('aria-label', (title ? title + ' ' : '') + (on ? 'favorilerden kaldır' : 'favorilere ekle'));
    }
  }
  function syncButtons() {
    var ids = get().map(function(item) { return item.id; });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn) {
      paintButton(btn, ids.indexOf(String(btn.dataset.wishlistToggle)) !== -1);
    });
  }
  function snapshotFromButton(btn) {
    var card = btn.closest('.product-card');
    var image = btn.dataset.productImage || '';
    if (!image && card) {
      var img = card.querySelector('img');
      image = img ? (img.currentSrc || img.src || '') : '';
    }
    var url = btn.dataset.productUrl || (card && card.dataset.productUrl) || '';
    var price = btn.dataset.productPrice || '';
    if (!price && card) {
      var priceEl = card.querySelector('.product-card__price .price');
      price = priceEl ? priceEl.textContent.trim() : '';
    }
    return {
      id: String(btn.dataset.wishlistToggle || ''),
      title: btn.dataset.productTitle || 'Ürün',
      handle: btn.dataset.productHandle || '',
      url: url,
      image: image,
      price: price,
      variantId: btn.dataset.variantId || ''
    };
  }
  function cardHtml(item) {
    var atc = item.variantId
      ? '<button type="button" class="product-card__mobile-atc btn btn-primary btn-sm btn-full" data-pc-atc="' + escAttr(item.variantId) + '" data-product-title="' + escAttr(item.title) + '">Sepete Ekle</button>'
      : '';
    return '<div class="product-card" data-product-id="' + escAttr(item.id) + '" data-product-url="' + escAttr(item.url) + '">' +
      '<a href="' + escAttr(item.url) + '" class="product-card__link-overlay" tabindex="-1" aria-hidden="true"></a>' +
      '<div class="product-card__media">' +
        (item.image ? '<img class="product-card__img product-card__img--main" src="' + escAttr(item.image) + '" alt="' + escAttr(item.title) + '" loading="lazy">' : '') +
      '</div>' +
      '<div class="product-card__info">' +
        '<div class="product-card__title"><a href="' + escAttr(item.url) + '" class="product-card__title-link">' + escHtml(item.title) + '</a></div>' +
        (item.price ? '<div class="product-card__price"><span class="price">' + escHtml(item.price) + '</span></div>' : '') +
        atc +
        '<button type="button" class="btn btn-secondary btn-sm btn-full wishlist-card__remove" data-wishlist-toggle="' + escAttr(item.id) + '" data-product-title="' + escAttr(item.title) + '" data-product-url="' + escAttr(item.url) + '" data-product-image="' + escAttr(item.image) + '" data-product-price="' + escAttr(item.price) + '" data-variant-id="' + escAttr(item.variantId) + '">Favorilerden kaldır</button>' +
      '</div></div>';
  }
  function renderPage(items) {
    var grid = document.getElementById('WishlistGrid');
    if (!grid) return;
    items = items || get();
    var empty = document.getElementById('WishlistEmpty');
    var lead = document.getElementById('WishlistLead');
    if (!items.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      if (lead) lead.textContent = 'Beğendiğiniz ürünler bu cihazda saklanır.';
      return;
    }
    if (empty) empty.hidden = true;
    if (lead) lead.textContent = items.length + ' ürün favorilerinizde.';
    grid.innerHTML = items.map(cardHtml).join('');
    syncButtons();
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var snap = snapshotFromButton(btn);
    if (!snap.id || !snap.url) {
      showToast('Bu ürün favorilere eklenemedi.', 'error');
      return;
    }
    var items = get();
    var idx = -1;
    items.forEach(function(item, i) { if (item.id === snap.id) idx = i; });
    var added;
    if (idx > -1) {
      items.splice(idx, 1);
      added = false;
    } else {
      items.unshift(snap);
      added = true;
    }
    save(items);
    var title = snap.title || '';
    showToast(
      added ? (title ? '"' + title.slice(0, 42) + '" favorilere eklendi.' : 'Favorilere eklendi.') : 'Favorilerden kaldırıldı.',
      undefined,
      added ? { href: WISH_URL, label: 'Favorilerim' } : { href: WISH_URL, label: 'Listeyi gör' }
    );
  });

  function showWishlistRoute() {
    if (location.pathname.indexOf('favoriler') === -1) return;
    var route = document.getElementById('WishlistRoute');
    if (!route) return;
    route.hidden = false;
    var main = document.getElementById('MainContent');
    if (main) {
      Array.prototype.forEach.call(main.children, function(child) {
        if (child !== route) child.hidden = true;
      });
    }
    document.title = 'Favorilerim | Stork Home & Baby';
    renderPage();
  }

  syncButtons();
  updateCount();
  renderPage();
  showWishlistRoute();
  window.bebefixSyncWishlistButtons = syncButtons;
})();

/* ── Ürün sayfası / Quick View etkileşimleri ─────────────── */
function bebefixInitProductMain(root) {
  root = root || document;
  var section = root.querySelector('.product-page');
  if (!section || section.dataset.bebefixProductReady) return;
  var layout = section.querySelector('.product-page__layout');
  if (!layout) return;
  section.dataset.bebefixProductReady = '1';

  var thumbs = Array.from(layout.querySelectorAll('.product-gallery__thumb'));
  var mainImg = layout.querySelector('#ProductMainImg');
  var prevBtn = layout.querySelector('#GalleryPrev');
  var nextBtn = layout.querySelector('#GalleryNext');
  var currentIdx = 0;

  function goTo(idx) {
    if (!mainImg || !thumbs.length) return;
    idx = Math.max(0, Math.min(idx, thumbs.length - 1));
    var thumb = thumbs[idx];
    var newSrc = thumb.dataset.src;
    var newSrcset = thumb.dataset.srcset;

    if (idx !== currentIdx || !mainImg.getAttribute('src')) {
      mainImg.classList.add('is-loading');
      var tmp = new Image();
      tmp.onload = function() {
        mainImg.src = newSrc;
        if (newSrcset) mainImg.srcset = newSrcset;
        else mainImg.removeAttribute('srcset');
        mainImg.classList.remove('is-loading');
      };
      tmp.onerror = function() {
        mainImg.src = newSrc;
        mainImg.classList.remove('is-loading');
      };
      tmp.src = newSrc;
    }

    currentIdx = idx;
    thumbs.forEach(function(t) {
      t.classList.remove('active');
      t.setAttribute('aria-pressed', 'false');
    });
    thumb.classList.add('active');
    thumb.setAttribute('aria-pressed', 'true');

    var thumbsWrap = layout.querySelector('#GalleryThumbs');
    if (thumbsWrap) {
      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
    if (prevBtn) prevBtn.disabled = currentIdx === 0;
    if (nextBtn) nextBtn.disabled = currentIdx === thumbs.length - 1;
  }

  section._bebefixGalleryGoTo = goTo;
  section._bebefixGalleryThumbs = thumbs;

  if (thumbs.length) {
    goTo(0);
    thumbs.forEach(function(t, i) {
      t.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
      t.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(i);
      });
    });
    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(currentIdx - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(currentIdx + 1);
      });
    }
  }

  var mainWrap = layout.querySelector('.product-gallery__main-wrap');
  if (mainWrap && thumbs.length > 1) {
    var touchStartX = 0;
    var touchStartY = 0;
    mainWrap.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });
    mainWrap.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].screenX - touchStartX;
      var dy = e.changedTouches[0].screenY - touchStartY;
      if (Math.abs(dx) < 30 || Math.abs(dy) > Math.abs(dx)) return;
      if (dx < 0) goTo(currentIdx + 1);
      else goTo(currentIdx - 1);
    }, { passive: true });
  }

  section.querySelectorAll('.tab-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var id = this.dataset.tab;
      section.querySelectorAll('.tab-btn').forEach(function(b) {
        b.classList.remove('active');
        b.setAttribute('aria-selected', 'false');
      });
      section.querySelectorAll('.tab-panel').forEach(function(p) { p.classList.remove('active'); });
      this.classList.add('active');
      this.setAttribute('aria-selected', 'true');
      var panel = section.querySelector('#tab-' + id);
      if (panel) panel.classList.add('active');
    });
  });

  var ratingLink = layout.querySelector('.product-info__rating-count');
  if (ratingLink) {
    ratingLink.addEventListener('click', function(e) {
      e.preventDefault();
      var reviewsBtn = section.querySelector('[data-tab="reviews"]');
      if (reviewsBtn) {
        reviewsBtn.click();
        reviewsBtn.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  var qty = layout.querySelector('#Quantity');
  layout.querySelector('#QtyMinus')?.addEventListener('click', function(e) {
    e.preventDefault();
    if (!qty) return;
    var v = parseInt(qty.value, 10) || 1;
    if (v > 1) qty.value = v - 1;
    window.bebefixRefreshProductWhatsApp?.();
  });
  layout.querySelector('#QtyPlus')?.addEventListener('click', function(e) {
    e.preventDefault();
    if (!qty) return;
    var v = parseInt(qty.value, 10) || 1;
    if (v < 99) qty.value = v + 1;
    window.bebefixRefreshProductWhatsApp?.();
  });

  var atcBtn = layout.querySelector('.product-info__atc-btn');
  var stickyATC = section.querySelector('#StickyATC');
  if (atcBtn && stickyATC && !section.closest('.qv-modal__content')) {
    var obs = new IntersectionObserver(function(entries) {
      var visible = entries[0].isIntersecting;
      stickyATC.style.display = visible ? 'none' : 'flex';
      stickyATC.setAttribute('aria-hidden', visible ? 'true' : 'false');
    }, { threshold: 0.1 });
    obs.observe(atcBtn);
  }

  section.querySelectorAll('.review-helpful-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (this.dataset.voted) return;
      this.dataset.voted = '1';
      var m = this.textContent.match(/\((\d+)\)/);
      if (m) {
        var n = parseInt(m[1], 10) + 1;
        this.textContent = this.textContent.replace(/\(\d+\)/, '(' + n + ')');
      }
      this.style.borderColor = 'var(--color-accent)';
      this.style.color = 'var(--color-accent)';
    });
  });

  (function initProductUrgency() {
    var urgencyRoot = layout.querySelector('[data-bebefix-urgency]');
    if (!urgencyRoot) return;

    var pid = parseInt(urgencyRoot.dataset.productId, 10) || 1;
    var viewMin = parseInt(urgencyRoot.dataset.viewMin, 10) || 6;
    var viewMax = parseInt(urgencyRoot.dataset.viewMax, 10) || 38;
    var cartMin = parseInt(urgencyRoot.dataset.cartMin, 10) || 2;
    var cartMax = parseInt(urgencyRoot.dataset.cartMax, 10) || 14;
    var soldMin = parseInt(urgencyRoot.dataset.soldMin, 10) || 8;
    var soldMax = parseInt(urgencyRoot.dataset.soldMax, 10) || 52;
    var viewEl = urgencyRoot.querySelector('[data-urgency-viewers]');
    var cartEl = urgencyRoot.querySelector('[data-urgency-cart]');
    var soldEl = urgencyRoot.querySelector('[data-urgency-sold]');
    var viewRow = viewEl && viewEl.closest('.product-urgency__item');
    var cartRow = cartEl && cartEl.closest('.product-urgency__item');
    var soldRow = soldEl && soldEl.closest('.product-urgency__item');
    var todayKey = (function() {
      var d = new Date();
      return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
    })();

    function seeded(seed) {
      var x = Math.sin(seed) * 10000;
      return x - Math.floor(x);
    }
    function pick(seed, min, max) {
      return min + Math.floor(seeded(seed) * (max - min + 1));
    }
    function bump(n, min, max, spread) {
      var delta = Math.floor(Math.random() * (spread * 2 + 1)) - spread;
      return Math.max(min, Math.min(max, n + delta));
    }
    function flash(row) {
      if (!row) return;
      row.classList.add('is-updated');
      window.setTimeout(function() { row.classList.remove('is-updated'); }, 600);
    }

    var viewers = pick(pid * 7 + 3, viewMin, viewMax);
    var inCart = pick(pid * 13 + 5, cartMin, Math.min(cartMax, viewers - 2));
    var soldToday = pick(pid * 17 + todayKey, soldMin, soldMax);

    function paint() {
      if (viewEl) viewEl.textContent = String(viewers);
      if (cartEl) cartEl.textContent = String(inCart);
      if (soldEl) soldEl.textContent = String(soldToday);
    }
    paint();

    function tick() {
      var prevView = viewers;
      var prevCart = inCart;
      var prevSold = soldToday;
      viewers = bump(viewers, viewMin, viewMax, 3);
      inCart = bump(inCart, cartMin, Math.min(cartMax, viewers - 1), 2);
      if (Math.random() < 0.42 && soldToday < soldMax) soldToday += 1;
      paint();
      if (viewers !== prevView) flash(viewRow);
      if (inCart !== prevCart) flash(cartRow);
      if (soldToday !== prevSold) flash(soldRow);
      window.setTimeout(tick, 8000 + Math.floor(Math.random() * 7000));
    }
    window.setTimeout(tick, 8000 + Math.floor(Math.random() * 4000));
  })();

  try {
    var handle = layout.dataset.productHandle;
    if (handle) {
      var rv = JSON.parse(localStorage.getItem('bebefix_rv') || '[]');
      var item = {
        handle: handle,
        title: layout.dataset.productTitle || '',
        price: parseInt(layout.dataset.productPrice, 10) || 0,
        image: layout.dataset.productImage || '',
        url: layout.dataset.productUrl || ''
      };
      rv = rv.filter(function(r) { return r.handle !== item.handle; });
      rv.unshift(item);
      localStorage.setItem('bebefix_rv', JSON.stringify(rv.slice(0, 10)));
    }
  } catch (e) {}
}

function bebefixInitProductVariants(root) {
  root = root || document;
  var section = root.querySelector('.product-page');
  var layout = section && section.querySelector('.product-page__layout');
  if (!layout || layout.dataset.bebefixVariantsReady) return;
  var form = layout.querySelector('#ProductForm');
  if (!form) return;
  var scriptEl = root.querySelector('#ProductVariantsJSON');
  if (!scriptEl) return;

  var variants;
  try { variants = JSON.parse(scriptEl.textContent); } catch (e) { return; }
  if (!variants || !variants.length) return;
  layout.dataset.bebefixVariantsReady = '1';

  function syncGalleryForVariant(variant) {
    if (!variant || !variant.featured_image || !section._bebefixGalleryGoTo || !section._bebefixGalleryThumbs) return;
    var vBase = variant.featured_image.split('?')[0];
    section._bebefixGalleryThumbs.forEach(function(t, i) {
      var tBase = (t.dataset.src || '').split('?')[0];
      if (!tBase) return;
      if (vBase === tBase || vBase.indexOf(tBase) !== -1 || tBase.indexOf(vBase) !== -1) {
        section._bebefixGalleryGoTo(i);
      }
    });
  }

  var selectedOptions = {};
  form.querySelectorAll('[data-option]').forEach(function(group) {
    group.querySelectorAll('[data-value]').forEach(function(btn) {
      if (btn.classList.contains('active')) selectedOptions[group.dataset.option] = btn.dataset.value;
    });
  });

  function seedSelectedOptionsFromVariant(variant) {
    if (!variant) return;
    variant.option_names.forEach(function(name, i) {
      selectedOptions[name] = variant.options[i];
    });
  }

  function findVariantById(id) {
    if (!id) return null;
    return variants.find(function(v) { return String(v.id) === String(id); }) || null;
  }

  var initialVariant = findVariantById(form.querySelector('#VariantId')?.value);
  if (initialVariant) seedSelectedOptionsFromVariant(initialVariant);

  function findVariant() {
    var optionGroups = form.querySelectorAll('[data-option]');

    if (!optionGroups.length) {
      return initialVariant || variants.find(function(v) { return v.available; }) || variants[0];
    }

    var match = variants.find(function(v) {
      return v.option_names.every(function(name, i) {
        if (selectedOptions[name] === undefined) return true;
        return v.options[i] === selectedOptions[name];
      });
    });
    if (match) return match;

    if (initialVariant) return initialVariant;
    return variants.find(function(v) { return v.available; }) || variants[0];
  }

  function updateProductWhatsAppLink(variant) {
    var waBtn = layout.querySelector('#ProductWhatsAppBtn');
    if (!waBtn) return;
    var base = (waBtn.getAttribute('data-wa-base') || 'https://wa.me/905343345577').split('?')[0].split('#')[0];
    var qtyEl = layout.querySelector('#Quantity');
    var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
    var title = waBtn.getAttribute('data-product-title') || document.title;
    var url = waBtn.getAttribute('data-product-url') || window.location.href;
    var lines = [
      'Merhaba Stork,',
      '',
      'Aşağıdaki ürünü sipariş etmek istiyorum:',
      '',
      title,
      url
    ];
    if (variant && variant.title && variant.title !== 'Default Title') {
      lines.push('', 'Seçenek: ' + variant.title);
    }
    if (variant && variant.sku) lines.push('Stok kodu: ' + variant.sku);
    lines.push('', 'Adet: ' + qty);
    if (variant && typeof variant.price === 'number') {
      lines.push('Birim fiyat: ' + formatMoney(variant.price));
    }
    waBtn.href = base + '?text=' + encodeURIComponent(lines.join('\n'));
  }

  window.bebefixRefreshProductWhatsApp = function() {
    updateProductWhatsAppLink(findVariant());
  };

  function updateForm(variant) {
    var vidInput = form.querySelector('#VariantId');
    var priceEl = layout.querySelector('#ProductPrice');
    var cmpEl = layout.querySelector('#ProductCompare');
    var atcBtn = layout.querySelector('#AddToCartBtn');
    var skuEl = layout.querySelector('#ProductSKU');
    if (!variant) {
      if (atcBtn) { atcBtn.disabled = true; atcBtn.innerHTML = 'Mevcut Değil'; }
      return;
    }
    if (vidInput) vidInput.value = variant.id;
    var wishBtn = layout.querySelector('[data-wishlist-toggle]');
    if (wishBtn) {
      wishBtn.dataset.variantId = String(variant.id);
      if (typeof variant.price === 'number') wishBtn.dataset.productPrice = formatMoney(variant.price);
    }
    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price || 0);
      priceEl.classList.toggle('price--sale', variant.compare_at_price > variant.price);
    }
    if (cmpEl) {
      if (variant.compare_at_price > variant.price) {
        cmpEl.textContent = formatMoney(variant.compare_at_price);
        cmpEl.style.display = '';
      } else {
        cmpEl.style.display = 'none';
      }
    }
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.innerHTML = variant.available
        ? '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>Sepete Ekle'
        : 'Tükendi';
    }
    if (skuEl && variant.sku) skuEl.textContent = variant.sku;
    syncGalleryForVariant(variant);
    var stockEl = layout.querySelector('.product-info__stock');
    if (stockEl) {
      stockEl.className = 'product-info__stock ' + (variant.available ? 'in-stock' : 'out-stock');
      stockEl.innerHTML = variant.available
        ? '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>Stokta Var'
        : 'Stokta Yok';
    }
    updateProductWhatsAppLink(variant);
  }

  form.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-option] [data-value]');
    if (!btn) return;
    var group = btn.closest('[data-option]');
    if (!group) return;
    group.querySelectorAll('[data-value]').forEach(function(b) { b.classList.remove('active'); });
    btn.classList.add('active');
    selectedOptions[group.dataset.option] = btn.dataset.value;
    var optLabel = layout.querySelector('#OptionVal' + (Array.from(form.querySelectorAll('[data-option]')).indexOf(group) + 1));
    if (optLabel) optLabel.textContent = btn.dataset.value;
    updateForm(findVariant());
  });

  updateForm(findVariant());
}

function bebefixBootProductPage(root) {
  bebefixInitProductMain(root || document);
  bebefixInitProductVariants(root || document);
  window.bebefixSyncWishlistButtons?.();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { bebefixBootProductPage(); });
} else {
  bebefixBootProductPage();
}

/* ── Karanlık Mod ─────────────────────────────────────────── */
(function() {
  var key = 'bebefix_theme';
  var saved = localStorage.getItem(key);
  if (saved === 'dark') document.documentElement.setAttribute('data-theme','dark');
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-theme-toggle]');
    if (!btn) return;
    var isDark = document.documentElement.getAttribute('data-theme') === 'dark';
    document.documentElement.setAttribute('data-theme', isDark ? 'light' : 'dark');
    try { localStorage.setItem(key, isDark ? 'light' : 'dark'); } catch(x){}
  });
})();

/* ── Hero Slider ──────────────────────────────────────────── */
function initHeroSlider(root) {
  if (!root) return;

  if (root._heroDestroy) root._heroDestroy();

  var autoplay = root.dataset.autoplay !== 'false';
  var interval = parseInt(root.dataset.interval, 10) || 6000;
  var timer = null;
  var userPaused = false;
  var index = 0;
  var isRangeNav = root.classList.contains('hero-slider--range');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function getSlides() {
    return Array.from(root.querySelectorAll('[data-hero-slide]'));
  }

  function getDots() {
    return Array.from(root.querySelectorAll('[data-hero-dot]'));
  }

  function getRangeItems() {
    return Array.from(root.querySelectorAll('button.hero-slider__range-item[data-hero-range]'));
  }

  function syncIndexFromDom() {
    var slides = getSlides();
    var active = slides.findIndex(function(s) { return s.classList.contains('is-active'); });
    index = active >= 0 ? active : 0;
    return slides;
  }

  function canAutoplay() {
    return autoplay && getSlides().length > 1 && !userPaused;
  }

  function restartRangeProgress() {
    getRangeItems().forEach(function(item, n) {
      var fill = item.querySelector('.hero-slider__range-fill');
      var knob = item.querySelector('.hero-slider__range-knob');
      if (!fill) return;
      fill.style.animation = 'none';
      if (knob) knob.style.animation = 'none';
      void fill.offsetWidth;
      if (n === index && canAutoplay()) {
        fill.style.animation = '';
        if (knob) knob.style.animation = '';
      }
    });
  }

  function revealActiveSlide(slide) {
    if (!slide) return;
    if (reducedMotion) {
      slide.classList.add('is-revealed');
      return;
    }
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        slide.classList.add('is-revealed');
      });
    });
  }

  function goTo(i) {
    if (typeof i !== 'number' || isNaN(i)) return;
    var slides = getSlides();
    if (!slides.length) return;
    index = (i + slides.length) % slides.length;
    slides.forEach(function(slide, n) {
      slide.classList.remove('is-revealed');
      slide.classList.toggle('is-active', n === index);
    });
    getDots().forEach(function(dot, n) {
      dot.classList.toggle('is-active', n === index);
      dot.setAttribute('aria-selected', n === index ? 'true' : 'false');
    });
    getRangeItems().forEach(function(item, n) {
      item.classList.toggle('is-active', n === index);
      item.setAttribute('aria-selected', n === index ? 'true' : 'false');
    });
    revealActiveSlide(slides[index]);
    restartRangeProgress();
    root.dispatchEvent(new CustomEvent('hero:slidechange', { detail: { index: index } }));
  }

  function next() { goTo(index + 1); }
  function prev() { goTo(index - 1); }

  function stopAutoplay() {
    if (timer) { clearInterval(timer); timer = null; }
  }

  function startAutoplay() {
    if (!canAutoplay()) return;
    stopAutoplay();
    timer = setInterval(next, interval);
  }

  function syncAutoplay() {
    if (canAutoplay()) startAutoplay();
    else stopAutoplay();
  }

  function onRangePick(btn) {
    if (!btn) return;
    var i = parseInt(btn.getAttribute('data-hero-range'), 10);
    if (isNaN(i)) return;
    goTo(i);
    syncAutoplay();
  }

  function onPauseToggle(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    userPaused = !userPaused;
    var pauseBtn = root.querySelector('[data-hero-pause]');
    if (pauseBtn) {
      pauseBtn.classList.toggle('is-paused', userPaused);
      pauseBtn.setAttribute('aria-label', userPaused ? 'Slayt geçişini sürdür' : 'Slayt geçişini duraklat');
      pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
    }
    syncAutoplay();
    restartRangeProgress();
  }

  function onClick(e) {
    var dot = e.target.closest('[data-hero-dot]');
    if (dot && root.contains(dot)) {
      var dotIndex = parseInt(dot.getAttribute('data-hero-dot'), 10);
      if (!isNaN(dotIndex)) { goTo(dotIndex); syncAutoplay(); }
      return;
    }
    if (e.target.closest('[data-hero-prev]')) {
      prev();
      syncAutoplay();
      return;
    }
    if (e.target.closest('[data-hero-next]')) {
      next();
      syncAutoplay();
    }
  }

  function onKeydown(e) {
    var rangeBtn = e.target.closest('button.hero-slider__range-item[data-hero-range]');
    if (!rangeBtn || !root.contains(rangeBtn)) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onRangePick(rangeBtn);
    }
  }

  var touchStartX = 0;
  function onTouchStart(e) {
    touchStartX = e.changedTouches[0].clientX;
  }
  function onTouchEnd(e) {
    var dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) < 40) return;
    if (dx < 0) next(); else prev();
    syncAutoplay();
  }

  root.addEventListener('click', onClick);
  root.addEventListener('keydown', onKeydown);
  root.addEventListener('touchstart', onTouchStart, { passive: true });
  root.addEventListener('touchend', onTouchEnd, { passive: true });

  if (!isRangeNav) {
    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);
  }

  root._heroGoTo = goTo;
  root._heroTogglePause = onPauseToggle;
  root._heroPickRange = onRangePick;
  root._heroDestroy = function() {
    stopAutoplay();
    root.removeEventListener('click', onClick);
    root.removeEventListener('keydown', onKeydown);
    root.removeEventListener('touchstart', onTouchStart);
    root.removeEventListener('touchend', onTouchEnd);
    if (!isRangeNav) {
      root.removeEventListener('mouseenter', stopAutoplay);
      root.removeEventListener('mouseleave', startAutoplay);
      root.removeEventListener('focusin', stopAutoplay);
      root.removeEventListener('focusout', startAutoplay);
    }
    delete root._heroGoTo;
    delete root._heroTogglePause;
    delete root._heroPickRange;
    delete root._heroDestroy;
  };

  var slides = syncIndexFromDom();
  if (!slides.length) return;
  var activeSlide = slides[index];
  if (activeSlide && !activeSlide.classList.contains('is-revealed')) {
    revealActiveSlide(activeSlide);
  }
  restartRangeProgress();
  syncAutoplay();
}

function bootHeroSliders() {
  document.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootHeroSliders);
} else {
  bootHeroSliders();
}

document.addEventListener('shopify:section:load', function(e) {
  var section = e.target;
  if (!section) return;
  var root = section.querySelector('[data-hero-slider]');
  if (section.matches && section.matches('[data-hero-slider]')) root = section;
  if (root) initHeroSlider(root);
});

document.addEventListener('click', function(e) {
  var rangeBtn = e.target.closest('button.hero-slider__range-item[data-hero-range]');
  if (rangeBtn) {
    var root = rangeBtn.closest('[data-hero-slider]');
    if (!root) return;
    if (!root._heroPickRange) initHeroSlider(root);
    if (root._heroPickRange) {
      e.preventDefault();
      root._heroPickRange(rangeBtn);
    }
    return;
  }
  var pauseEl = e.target.closest('[data-hero-pause]');
  if (pauseEl) {
    var heroRoot = pauseEl.closest('[data-hero-slider]');
    if (!heroRoot) return;
    if (!heroRoot._heroTogglePause) initHeroSlider(heroRoot);
    if (heroRoot._heroTogglePause) {
      e.preventDefault();
      heroRoot._heroTogglePause(e);
    }
  }
}, true);

/* ── Kategori sekmeleri (Momcozy shop tabs) ───────────────── */
function shopTabImageSrc(p) {
  var img = p.featured_image || '';
  if (img && typeof img === 'object') img = img.src || img.url || '';
  if (!img && p.images && p.images.length) {
    var first = p.images[0];
    img = typeof first === 'string' ? first : (first.src || '');
  }
  if (!img && p.image) img = typeof p.image === 'string' ? p.image : (p.image.src || '');
  return portraitProductImg(img || '');
}

function shopTabPriceNumber(value) {
  if (value == null || value === '') return 0;
  var n = parseFloat(String(value).replace(/\s/g, '').replace(',', '.'));
  return isNaN(n) ? 0 : n;
}

function renderShopTabProductCard(p) {
  var img = shopTabImageSrc(p);
  var variant = (p.variants && p.variants[0]) || {};
  var priceNum = shopTabPriceNumber(variant.price != null ? variant.price : (p.price != null ? p.price : p.price_min));
  var compareNum = shopTabPriceNumber(variant.compare_at_price != null ? variant.compare_at_price : p.compare_at_price_min);
  var price = formatMoneyFromSuggestDecimal(priceNum);
  var comparePrice = compareNum > priceNum
    ? '<span class="price--compare">' + formatMoneyFromSuggestDecimal(compareNum) + '</span>' : '';
  var salePct = compareNum > priceNum
    ? Math.round((1 - priceNum / compareNum) * 100) : 0;
  var tags = p.tags || '';
  var isNew = String(tags).indexOf('yeni') !== -1 || String(tags).indexOf('new') !== -1;
  var vid = variant.id || '';
  var titleAttr = escAttr(p.title);
  var titleHtml = escHtml(p.title);
  var url = p.url || (p.handle ? bebefixRoutesRoot() + 'products/' + p.handle : '#');
  var mobileAtc = vid
    ? '<button type="button" class="product-card__mobile-atc btn btn-primary btn-sm btn-full" data-pc-atc="' + vid + '" data-product-title="' + titleAttr + '">Sepete Ekle</button>'
    : '<button type="button" class="product-card__mobile-atc btn btn-secondary btn-sm btn-full" disabled style="opacity:.6;cursor:not-allowed;">Tükendi</button>';
  return '<div class="product-card" data-product-id="' + escAttr(String(p.id)) + '" data-product-url="' + escAttr(url) + '">' +
    '<a href="' + url + '" class="product-card__link-overlay" tabindex="-1" aria-hidden="true"></a>' +
    '<div class="product-card__media">' +
        (img ? '<img class="product-card__img product-card__img--main" src="' + escAttr(img) + '" alt="' + titleAttr + '" loading="lazy" draggable="false">' : '<div class="product-card__no-img" aria-hidden="true"><svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg></div>') +
      '<div class="product-card__badges" aria-hidden="true">' +
        (salePct > 0 ? '<span class="badge badge-sale">-%' + salePct + '</span>' : '') +
        (isNew ? '<span class="badge badge-new">Yeni</span>' : '') +
      '</div>' +
    '</div>' +
    '<div class="product-card__info">' +
      designGermanyBadgeHtml() +
      '<div class="product-card__title"><a href="' + url + '" class="product-card__title-link">' + titleHtml + '</a></div>' +
      '<div class="product-card__price"><span class="price' + (salePct > 0 ? ' price--sale' : '') + '">' + price + '</span>' + comparePrice + '</div>' +
      mobileAtc +
    '</div></div>';
}

function initShopTabs(root) {
  if (!root) return;
  if (root._shopTabsDestroy) root._shopTabsDestroy();

  var tabs = root.querySelectorAll('[data-mc-tab]');
  var panels = root.querySelectorAll('[data-mc-panel]');
  if (!tabs.length || !panels.length) return;

  var loadingPanels = new Set();

  function setTabFocusable(activeIdx) {
    tabs.forEach(function(t) {
      var on = t.getAttribute('data-mc-tab') === String(activeIdx);
      t.setAttribute('tabindex', on ? '0' : '-1');
    });
  }

  function shuffleProducts(list) {
    var arr = list.slice();
    var i;
    var j;
    var tmp;
    for (i = arr.length - 1; i > 0; i--) {
      j = Math.floor(Math.random() * (i + 1));
      tmp = arr[i];
      arr[i] = arr[j];
      arr[j] = tmp;
    }
    return arr;
  }

  function pickRandomProducts(list, limit) {
    return shuffleProducts(list).slice(0, limit);
  }

  function filterShopTabProducts(products, keywords, limit, handle) {
    var out = [];
    var i;
    var p;
    var title;
    var k;
    var kw;
    for (i = 0; i < products.length && out.length < limit; i++) {
      p = products[i];
      if (handle === 'kampanya') {
        if (p.compare_at_price_min > p.price_min) out.push(p);
        continue;
      }
      if (!keywords.length) continue;
      title = String(p.title || '').toLowerCase();
      for (k = 0; k < keywords.length; k++) {
        kw = keywords[k].trim().toLowerCase();
        if (kw && title.indexOf(kw) !== -1) {
          out.push(p);
          break;
        }
      }
    }
    return out;
  }

  function renderPanelProducts(panel, products) {
    var grid = panel.querySelector('[data-mc-product-grid]');
    var empty = panel.querySelector('[data-mc-empty]');
    if (!grid) return;
    if (products.length) {
      grid.innerHTML = products.map(renderShopTabProductCard).join('');
      if (empty) empty.setAttribute('hidden', '');
    } else if (empty) {
      empty.removeAttribute('hidden');
    }
  }

  function maybeLoadPanel(panel) {
    if (!panel || panel.getAttribute('data-mc-loaded') === 'true') return Promise.resolve();
    var handle = panel.getAttribute('data-collection');
    var limit = parseInt(panel.getAttribute('data-limit') || '8', 10);
    var grid = panel.querySelector('[data-mc-product-grid]');
    var loading = panel.querySelector('[data-mc-loading]');
    var empty = panel.querySelector('[data-mc-empty]');
    var keywords = (panel.getAttribute('data-fallback-keywords') || '').split(',').map(function(s) { return s.trim(); }).filter(Boolean);
    var pool = 50;
    if (!grid) return Promise.resolve();
    if (loadingPanels.has(panel)) return Promise.resolve();
    loadingPanels.add(panel);
    if (loading) loading.removeAttribute('hidden');
    if (empty) empty.setAttribute('hidden', '');

    function finish(products) {
      renderPanelProducts(panel, products);
      loadingPanels.delete(panel);
      if (loading) loading.setAttribute('hidden', '');
      panel.setAttribute('data-mc-loaded', 'true');
    }

    if (panel.getAttribute('data-one-per-category') === 'true') {
      var handles = (panel.getAttribute('data-sibling-collections') || '').split(',').map(function(s) { return s.trim(); }).filter(Boolean);
      if (!handles.length) {
        finish([]);
        return Promise.resolve();
      }
      return Promise.all(handles.map(function(h) {
        return fetchJSON(bebefixRoutesRoot() + 'collections/' + encodeURIComponent(h) + '/products.json?limit=' + pool)
          .then(function(data) {
            var products = (data && data.products) || [];
            return products.length ? pickRandomProducts(products, 1)[0] : null;
          })
          .catch(function() { return null; });
      })).then(function(items) {
        finish(shuffleProducts(items.filter(Boolean)));
      });
    }

    var collectionUrl = handle
      ? bebefixRoutesRoot() + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=' + pool
      : null;

    var childHandles = (panel.getAttribute('data-child-collections') || '').split(',').map(function(s) { return s.trim(); }).filter(Boolean);

    function fetchCollectionProducts(h, n) {
      return fetchJSON(bebefixRoutesRoot() + 'collections/' + encodeURIComponent(h) + '/products.json?limit=' + n)
        .then(function(data) { return (data && data.products) || []; })
        .catch(function() { return []; });
    }

    var collectionPromise = collectionUrl
      ? fetchCollectionProducts(handle, limit)
      : Promise.resolve([]);

    return collectionPromise.then(function(products) {
      if (products.length) {
        finish(pickRandomProducts(products, limit));
        return;
      }
      if (childHandles.length) {
        return Promise.all(childHandles.map(function(h) {
          return fetchCollectionProducts(h, pool);
        })).then(function(groups) {
          var merged = [];
          var seen = {};
          var g;
          var p;
          for (g = 0; g < groups.length; g++) {
            for (p = 0; p < groups[g].length; p++) {
              if (seen[groups[g][p].id]) continue;
              seen[groups[g][p].id] = true;
              merged.push(groups[g][p]);
            }
          }
          finish(pickRandomProducts(merged, limit));
        });
      }
      if (!keywords.length && handle !== 'kampanya') {
        finish([]);
        return;
      }
      return fetchJSON(bebefixRoutesRoot() + 'collections/all/products.json?limit=50').then(function(allData) {
        finish(pickRandomProducts(filterShopTabProducts((allData && allData.products) || [], keywords, 50, handle), limit));
      }).catch(function() {
        finish([]);
      });
    });
  }

  function activateTab(idx, opts) {
    opts = opts || {};
    var idxStr = String(idx);
    tabs.forEach(function(t) {
      var on = t.getAttribute('data-mc-tab') === idxStr;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on) {
        if (opts.focus) t.focus();
        t.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
      }
    });
    setTabFocusable(idx);
    var activePanel = null;
    panels.forEach(function(p) {
      var on = p.getAttribute('data-mc-panel') === idxStr;
      p.classList.toggle('is-active', on);
      if (on) {
        p.removeAttribute('hidden');
        activePanel = p;
      } else {
        p.setAttribute('hidden', '');
      }
    });
    if (activePanel) maybeLoadPanel(activePanel);
  }

  root._shopTabsActivate = activateTab;
  root._shopTabsDestroy = function() {
    loadingPanels.clear();
    delete root._shopTabsActivate;
    delete root._shopTabsDestroy;
  };

  var initial = root.querySelector('.mc-tab-panel.is-active');
  if (initial) maybeLoadPanel(initial);
}

function bootShopTabs() {
  document.querySelectorAll('[data-mc-shop-tabs]').forEach(initShopTabs);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootShopTabs);
} else {
  bootShopTabs();
}

document.addEventListener('shopify:section:load', function(e) {
  var section = e.target;
  if (!section) return;
  var root = section.querySelector('[data-mc-shop-tabs]');
  if (section.matches && section.matches('[data-mc-shop-tabs]')) root = section;
  if (root) initShopTabs(root);
});

document.addEventListener('click', function(e) {
  var tab = e.target.closest('[data-mc-tab]');
  if (!tab) return;
  var root = tab.closest('[data-mc-shop-tabs]');
  if (!root) return;
  if (!root._shopTabsActivate) initShopTabs(root);
  if (!root._shopTabsActivate) return;
  e.preventDefault();
  root._shopTabsActivate(tab.getAttribute('data-mc-tab'), { focus: false });
}, true);

document.addEventListener('keydown', function(e) {
  var tab = e.target.closest('[data-mc-tab]');
  if (!tab || tab.getAttribute('role') !== 'tab') return;
  var root = tab.closest('[data-mc-shop-tabs]');
  if (!root || !root._shopTabsActivate) return;
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-mc-tab]'));
  var idx = tabs.indexOf(tab);
  if (idx < 0) return;
  var next = -1;
  if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (idx + 1) % tabs.length;
  else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (idx - 1 + tabs.length) % tabs.length;
  else if (e.key === 'Home') next = 0;
  else if (e.key === 'End') next = tabs.length - 1;
  else return;
  e.preventDefault();
  var target = tabs[next];
  root._shopTabsActivate(target.getAttribute('data-mc-tab'), { focus: true });
});

/* ── Kaydırma Animasyonları ───────────────────────────────── */
(function() {
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); } });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('[data-animate]').forEach(function(el) { obs.observe(el); });
})();

/* ── Yukarı Çıkma Butonu ──────────────────────────────────── */
(function() {
  var btn = document.getElementById('BackToTop');
  if (!btn) return;
  window.addEventListener('scroll', function() { btn.classList.toggle('is-visible', window.scrollY > 400); }, { passive: true });
  btn.addEventListener('click', function() { window.scrollTo({ top: 0, behavior: 'smooth' }); });
})();

/* ── Son görüntülenenler: ai-features.js / RecentlyViewed + bebefix_recently_viewed ── */

/* ── AI Chatbot — Akıllı Türkçe Yanıt Sistemi ─────────────── */
(function() {
  'use strict';
  var toggle   = document.getElementById('ChatbotToggle');
  var win      = document.getElementById('ChatbotWindow');
  var sendBtn  = document.getElementById('ChatbotSend');
  var input    = document.getElementById('ChatbotInput');
  var msgs     = document.getElementById('ChatbotMsgs');
  var closeBtn = document.getElementById('ChatbotClose');
  var unread   = document.getElementById('ChatbotUnread');
  var iconOpen = toggle ? toggle.querySelector('.chatbot-icon-open') : null;
  var iconClose= toggle ? toggle.querySelector('.chatbot-icon-close') : null;
  if (!toggle || !win) return;

  var isOpen = false;
  var hasInteracted = false;

  /* ── Yardımcı: mesaj ekle ────────────────────────────────── */
  function addMsg(html, type, delay) {
    if (!msgs) return;
    return new Promise(function(res) {
      setTimeout(function() {
        var m = document.createElement('div');
        m.className = 'ai-chatbot__msg ai-chatbot__msg--' + type;
        m.innerHTML = html;
        msgs.appendChild(m);
        msgs.scrollTop = msgs.scrollHeight;
        res(m);
      }, delay || 0);
    });
  }

  /* ── Yazıyor indikatörü ──────────────────────────────────── */
  function showTyping() {
    var d = document.createElement('div');
    d.className = 'ai-chatbot__msg ai-chatbot__msg--bot ai-chatbot__typing';
    d.id = 'ChatbotTyping';
    d.innerHTML = '<span></span><span></span><span></span>';
    msgs.appendChild(d);
    msgs.scrollTop = msgs.scrollHeight;
    return d;
  }
  function removeTyping() {
    var t = document.getElementById('ChatbotTyping');
    if (t) t.remove();
  }

  /* ── Öneri butonları ─────────────────────────────────────── */
  function addSuggestions(list) {
    if (!msgs || !list || !list.length) return;
    var wrap = document.createElement('div');
    wrap.className = 'ai-chatbot__suggestions';
    list.forEach(function(s) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ai-chatbot__suggestion-btn';
      b.textContent = s;
      b.addEventListener('click', function() {
        wrap.remove();
        if (input) input.value = s;
        sendMessage();
      });
      wrap.appendChild(b);
    });
    msgs.appendChild(wrap);
    msgs.scrollTop = msgs.scrollHeight;
  }

  /* ── Yanıt Motoru — Türkçe anahtar kelime eşleme ────────── */
  var KB = [
    {
      keys: ['merhaba','selam','iyi günler','iyi akşamlar','hey','naber','nasılsın'],
      reply: 'Merhaba! 👋 Ben Stork Asistan\'ım. Ürünler, kargo, iade veya sipariş konularında size yardımcı olabilirim. Ne öğrenmek istersiniz?',
      suggestions: ['Kargo süresi nedir?', 'İade nasıl yapılır?', 'Hangi ürünler var?']
    },
    {
      keys: ['kargo','teslimat','gönderim','kaç günde','ne zaman gelir','hızlı kargo','aynı gün','gönder'],
      reply: '🚚 Kargo bilgileri:\n\n• <strong>Standart kargo:</strong> 3–5 iş günü — <strong>1000 TL altı 116 TL</strong>; <strong>1000 TL ve üzeri ücretsiz</strong>\n• <strong>Hızlı kargo:</strong> 1–2 iş günü — 29,99 TL\n• <strong>Aynı gün teslimat:</strong> Büyük şehirler, saat 14:00 öncesi siparişlerde 49,99 TL\n\nSiparişleriniz genellikle aynı gün kargoya verilir.',
      suggestions: ['Hangi kargo firması?', 'Siparişimi takip etmek istiyorum', 'İade nasıl yapılır?']
    },
    {
      keys: ['iade','geri gönder','para iadesi','değişim','ürünü beğenmedim','bozuk geldi','hasar'],
      reply: '✅ Teslimden itibaren <strong>15 gün</strong> içinde iade talebi alıyoruz.\n\nİade koşulları:\n• Ürün kullanılmamış ve orijinal ambalajında olmalı\n• 15 gün içinde talep edilmeli\n\nİade için: <strong>info@stork.com.tr</strong> veya WhatsApp +90 534 334 55 77.',
      suggestions: ['Kargo süresi nedir?', 'Ürün garantisi var mı?', 'Sipariş durumumu nasıl görebilirim?']
    },
    {
      keys: ['kek','çikolata','cikolata','muffin','airfryer','silikon','buz kalıbı','spatula'],
      reply: 'Stork Home & Baby yapışmaz silikon <strong>kek, çikolata, muffin, buz ve airfryer</strong> kalıpları satar. Kategorilerden size uygun olanı seçebilirsiniz.',
      suggestions: ['Kek kalıpları', 'Çikolata kalıpları', 'Airfryer', 'Setler']
    },
    {
      keys: ['fiyat','indirim','kampanya','kupon','iskonto','promosyon','para','kaç tl','kaç lira','ucuz'],
      reply: '💸 Güncel kampanyalarımız:\n\n• <strong>1000 TL ve üzeri</strong> alışverişlerde ücretsiz kargo; altında standart kargo <strong>116 TL</strong>\n• Yeni üyelere özel <strong>%10 indirim</strong> (bülten aboneliği ile)\n• Çok satanlar bölümünde <strong>%40\'a varan</strong> indirimli ürünler var!\n\nKampanya sayfamıza göz atmak ister misiniz?',
      suggestions: ['Kampanyalar', 'En çok satanlar', 'Yeni gelenler']
    },
    {
      keys: ['kalıp','kalip','kek kalıbı','tart'],
      reply: 'Kek kalıpları: baton, yarım küre, çiçek ve büyük şef modelleri. /collections/kek-kaliplari',
      suggestions: ['Kampanyalar', 'Fiyatlar', 'İletişim']
    },
    {
      keys: ['temizlik','nasıl temizlenir','bakım','montaj'],
      reply: '🧼 Üretici kılavuzundaki talimatları izleyin. Elektrikli modellerde fişi çekerek temizleyin.',
      suggestions: ['Garanti', 'İade', 'WhatsApp']
    },
    {
      keys: ['garanti','sağlam','dayanıklı','bozulur','ne kadar süre','kaç yıl'],
      reply: '🛡️ Ürünlerimiz <strong>2 yıl üretici garantisi</strong> ile satılmaktadır. Normal kullanımda şekil bozukluğu, çatlama veya renk değişimi olmaz. Sorun yaşarsanız ücretsiz değişim yapıyoruz!',
      suggestions: ['İade koşulları nedir?', 'Müşteri hizmetleri', 'Sipariş vermek istiyorum']
    },
    {
      keys: ['taksit','taksitli','kaç taksit','vade'],
      reply: 'Kredi kartında yaygın planlar <strong>2, 3, 6, 9 ve 12 taksit</strong>. Taksit sayısı banka ve karta göre değişir; ödeme adımında kartınıza uygun seçenekler listelenir. Banka kartlarında taksit genellikle uygulanmaz.',
      suggestions: ['Kapıda ödeme var mı?', 'Kargo ücreti nedir?', 'İade nasıl yapılır?']
    },
    {
      keys: ['sipariş','nasıl sipariş','nasıl alınır','satın al','nereden alırım','ödeme','kapıda ödeme'],
      reply: '🛒 Sipariş vermek çok kolay!\n\n1. İstediğiniz ürünü seçin\n2. "Sepete Ekle" butonuna tıklayın\n3. Sepetinizi kontrol edin\n4. Güvenli ödeme sayfasına geçin\n\n<strong>Ödeme seçenekleri:</strong> Kredi kartı, banka kartı, havale/EFT, kapıda ödeme\n\nTüm ödemeler 256-bit SSL ile korunur.',
      suggestions: ['Kapıda ödeme var mı?', 'Kargo ücreti nedir?', 'Taksit var mı?']
    },
    {
      keys: ['kapıda ödeme','nakit','kapıda'],
      reply: '✅ Evet, <strong>kapıda ödeme</strong> seçeneğimiz mevcuttur! Nakit veya kartlı ödeme yapabilirsiniz. Kapıda ödeme seçeneğinde +5 TL hizmet bedeli uygulanır.',
      suggestions: ['Kargo ücreti nedir?', 'Sipariş vermek istiyorum', 'Başka sorum var']
    },
    {
      keys: ['iletişim','telefon','mail','e-posta','müşteri hizmetleri','destek','yardım','ulaşmak'],
      reply: '📞 Bize ulaşabilirsiniz:\n\n• <strong>Telefon / WhatsApp:</strong> <a href="https://wa.me/905343345577" target="_blank" rel="noopener">+90 534 334 55 77</a>\n• <strong>E-posta:</strong> <a href="mailto:info@stork.com.tr">info@stork.com.tr</a>\n• <strong>Instagram, TikTok, Facebook, Pinterest:</strong> @stork.com.tr\n\nEn hızlı yanıt için WhatsApp veya e-posta kullanabilirsiniz.',
      suggestions: ['İade nasıl yapılır?', 'Sipariş durumum', 'Kargo bilgisi']
    },
    {
      keys: ['hediye','doğum günü','düğün','nişan','present','armağan'],
      reply: '🎁 Silikon kalıp setleri hediye için uygundur. Ürünler orijinal ambalajında gönderilir.',
      suggestions: ['Hediye paketleme var mı?', 'En popüler setler', 'Fiyat aralığı']
    },
    {
      keys: ['stok','var mı','tükendi','mevcut','satın alınabilir'],
      reply: 'Stok durumu ürün sayfasında anlık olarak güncellenmektedir. "Stokta Yok" yazan ürünler için ürün sayfasındaki "Beni Haberdar Et" butonunu kullanarak stok girişinde bildirim alabilirsiniz.',
      suggestions: ['Ürün aramak istiyorum', 'Popüler ürünler', 'Başka sorum var']
    },
    {
      keys: ['teşekkür','teşekkürler','sağ ol','tamam','anladım','harika','çok iyi'],
      reply: '😊 Rica ederim! Başka bir sorunuz olursa her zaman buradayım. İyi alışverişler! 🛍️',
      suggestions: ['Ürünlere bak', 'Kampanyalar', 'Sipariş ver']
    }
  ];

  function generateReply(text) {
    var lower = text.toLowerCase()
      .replace(/[ğ]/g, 'g').replace(/[ı]/g, 'i').replace(/[ö]/g, 'o')
      .replace(/[ü]/g, 'u').replace(/[ş]/g, 's').replace(/[ç]/g, 'c');

    for (var i = 0; i < KB.length; i++) {
      for (var j = 0; j < KB[i].keys.length; j++) {
        var k = KB[i].keys[j]
          .replace(/[ğ]/g, 'g').replace(/[ı]/g, 'i').replace(/[ö]/g, 'o')
          .replace(/[ü]/g, 'u').replace(/[ş]/g, 's').replace(/[ç]/g, 'c');
        if (lower.indexOf(k) !== -1) {
          return KB[i];
        }
      }
    }
    return {
      reply: 'Sorunuzu aldım. 🤔 Daha iyi yardımcı olabilmem için biraz daha detay verir misiniz? Ya da aşağıdaki konulardan birini seçebilirsiniz:',
      suggestions: ['Kargo bilgisi', 'İade koşulları', 'Kek kalıpları', 'İletişim']
    };
  }

  /* ── Mesaj gönder ────────────────────────────────────────── */
  function sendMessage() {
    var text = input ? input.value.trim() : '';
    if (!text) return;
    addMsg(text, 'user');
    if (input) input.value = '';
    hasInteracted = true;

    /* Öneri kutularını temizle */
    msgs.querySelectorAll('.ai-chatbot__suggestions').forEach(function(e) { e.remove(); });

    /* Yazıyor göster */
    var typing = showTyping();
    var delay = 600 + Math.random() * 600;

    setTimeout(function() {
      removeTyping();
      var result = generateReply(text);
      addMsg(result.reply.replace(/\n/g, '<br>'), 'bot');
      if (result.suggestions) addSuggestions(result.suggestions);
    }, delay);
  }

  /* ── Aç/Kapat ────────────────────────────────────────────── */
  function openChat() {
    isOpen = true;
    win.classList.add('is-open');
    win.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    if (iconOpen)  iconOpen.style.display  = 'none';
    if (iconClose) iconClose.style.display = '';
    if (unread) unread.style.display = 'none';
    setTimeout(function() { if (input) input.focus(); }, 200);
  }
  function closeChat() {
    isOpen = false;
    win.classList.remove('is-open');
    win.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    if (iconOpen)  iconOpen.style.display  = '';
    if (iconClose) iconClose.style.display = 'none';
  }

  toggle.addEventListener('click', function() { isOpen ? closeChat() : openChat(); });
  if (closeBtn) closeBtn.addEventListener('click', closeChat);
  if (sendBtn)  sendBtn.addEventListener('click', sendMessage);
  if (input) {
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); }
    });
  }

  /* ── İlk açılışta hoş geldin mesajı + öneriler ──────────── */
  /* Unread badge 3 sn sonra görünür */
  setTimeout(function() {
    if (!isOpen && unread) unread.style.display = 'flex';
  }, 3000);

  /* İlk açılışta welcome mesajı + öneriler ekle */
  toggle.addEventListener('click', function() {
    if (isOpen && !hasInteracted && msgs && msgs.children.length <= 1) {
      setTimeout(function() {
        addSuggestions(['Kargo süresi nedir?', 'İade nasıl yapılır?', 'Kek kalıpları', 'Kampanyalar']);
      }, 300);
    }
  }, { once: true });

  /* ESC tuşuyla kapatma */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isOpen) closeChat();
  });
})();

/* ── Quick View Modal ────────────────────────────────────── */
(function() {
  var modal    = document.getElementById('QuickViewModal');
  var content  = document.getElementById('QuickViewContent');
  var closeBtn = document.getElementById('QuickViewClose');
  var backdrop = document.getElementById('QuickViewBackdrop');
  if (!modal) return;

  function openModal() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  window.bebefixCloseQuickView = closeModal;

  document.addEventListener('click', async function(e) {
    var btn = e.target.closest('[data-quick-view]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var handle = btn.dataset.quickView;
    if (!handle) return;
    if (content) content.innerHTML = '<div class="qv-modal__loading"><svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--color-primary)" stroke-width="2.5" class="loading-spinner"><path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" opacity=".2"/><path d="M21 12a9 9 0 0 1-9 9"/></svg><p>Yükleniyor...</p></div>';
    openModal();
    try {
      var res = await fetch('/products/' + handle + '?sections=product-main', { headers: {'X-Requested-With':'XMLHttpRequest'} });
      if (res.ok) {
        var data = await res.json();
        var html = data['product-main'] || '';
        if (content) content.innerHTML = html || '<div style="padding:32px;text-align:center;"><a href="/products/' + handle + '" class="btn btn-primary">Ürün Sayfasına Git</a></div>';
        bebefixBootProductPage(content);
      } else {
        if (content) content.innerHTML = '<div style="padding:32px;text-align:center;font-size:14px;color:var(--color-text-muted);">Yüklenemedi. <a href="/products/' + handle + '" style="color:var(--color-primary);">Ürün sayfasına git →</a></div>';
      }
    } catch(err) {
      if (content) content.innerHTML = '<div style="padding:32px;text-align:center;font-size:14px;color:var(--color-text-muted);">Bir hata oluştu. <a href="/products/' + handle + '" style="color:var(--color-primary);">Ürün sayfasına git →</a></div>';
    }
  });

  closeBtn?.addEventListener('click', closeModal);
  backdrop?.addEventListener('click', closeModal);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeModal(); });
})();

/* ── SSS sayfası — h2/h3 başlıklarını accordion yap ─────────── */
(function initStorkPageFaq() {
  document.querySelectorAll('.bebefix-about--faq .bebefix-about__intro-content').forEach(function (body) {
    if (body.dataset.faqReady) return;
    var headings = body.querySelectorAll('h2, h3');
    if (!headings.length) return;
    body.dataset.faqReady = '1';
    headings.forEach(function (heading) {
      if (heading.closest('details')) return;
      var details = document.createElement('details');
      var summary = document.createElement('summary');
      summary.textContent = heading.textContent;
      details.appendChild(summary);
      var answer = document.createElement('div');
      answer.className = 'bebefix-faq__answer';
      var node = heading.nextElementSibling;
      var toMove = [];
      while (node && !/^H[23]$/.test(node.tagName)) {
        toMove.push(node);
        node = node.nextElementSibling;
      }
      if (!toMove.length) {
        var p = document.createElement('p');
        p.textContent = 'Detaylı bilgi için müşteri hizmetlerimizle iletişime geçebilirsiniz.';
        answer.appendChild(p);
      } else {
        toMove.forEach(function (el) { answer.appendChild(el); });
      }
      details.appendChild(answer);
      heading.replaceWith(details);
    });
  });
})();
